// js/sections/at-mega-menu.js
const atHandleMenuToggle = (event) => {
  const button = event.currentTarget;
  const targetSelector = button.getAttribute('data-target');
  const atMegaMenu = button.closest('.at-mega-menu');

  if (atMegaMenu) {
    const targetMenu = atMegaMenu.querySelector(targetSelector);

    if (targetMenu) {
      const isMenuAlreadyActive = targetMenu.classList.contains('show');

      atMegaMenu.querySelectorAll('.child-submenu__nav.show').forEach(menu => {
        if (menu !== targetMenu) {
          menu.classList.remove('show');
          const relatedButton = atMegaMenu.querySelector(`[data-target="#${menu.id}"]`);
          if (relatedButton) {
            relatedButton.classList.remove('active');
          }
        }
      });
      
      if (!isMenuAlreadyActive) {
        targetMenu.classList.add('show');
        button.classList.add('active');
      }
    }
  }
};

const atHandleTabToggle = (event) => {
  const button = event.currentTarget;
  const targetSelector = button.getAttribute('data-target');
  const atMegaMenu = button.closest('.at-mega-menu');

  if (atMegaMenu) {
    const targetTab = atMegaMenu.querySelector(targetSelector);
    
    if (targetTab) {
      atMegaMenu.querySelectorAll('.product-tab.show').forEach(tab => {
        if (tab !== targetTab) {
          tab.classList.remove('show');
          const relatedButton = atMegaMenu.querySelector(`[data-target="#${tab.id}"]`);
          if (relatedButton) {
            relatedButton.classList.remove('active');
          }
        }
      });

      const isTabAlreadyActive = targetTab.classList.contains('show');
      if (!isTabAlreadyActive) {
        targetTab.classList.add('show');
        button.classList.add('active');
      }
    }
  }
};

const handleMobileTabToggle = (event) => {
  const button = event.currentTarget;
  const targetSelector = button.getAttribute('data-target');
  const atPanelWrapper = button.closest('.at-panel__wrapper');

  if (atPanelWrapper) {
    const targetTab = atPanelWrapper.querySelector(targetSelector);

    if (targetTab) {
      atPanelWrapper.querySelectorAll('.product-tab.show').forEach(tab => {
        if (tab !== targetTab) {
          tab.classList.remove('show');
          const relatedButton = atPanelWrapper.querySelector(`[data-target="#${tab.id}"]`);
          if (relatedButton) {
            relatedButton.classList.remove('active');
          }
        }
      });

      if (!targetTab.classList.contains('show')) {
        targetTab.classList.add('show');
        button.classList.add('active');
      }
    }
  }
};

const handleMobileMegaMenuToggle = (event) => {
  const button = event.currentTarget;
  const atChildToggleWrapper = button.closest('.child-toggle-wrapper');
  
  if (atChildToggleWrapper) {
    const toggleWrapper = atChildToggleWrapper.querySelector('.at-toggle__wrapper');
    
    if (toggleWrapper) {
      const allToggleWrappers = document.querySelectorAll('.at-toggle__wrapper');
      allToggleWrappers.forEach(wrapper => {
        if (wrapper !== toggleWrapper) {
          wrapper.classList.add('hidden');
          const associatedButton = wrapper.closest('.child-toggle-wrapper').querySelector('button');
          if (associatedButton) {
            associatedButton.setAttribute('aria-expanded', 'false');
          }
        }
      });
      
      toggleWrapper.classList.toggle('hidden');
      
      const ariaExpanded = toggleWrapper.classList.contains('hidden') ? 'false' : 'true';
      button.setAttribute('aria-expanded', ariaExpanded);
    }
  }
};

const atHandleCollectionTabToggle = (event) => {
  const button = event.currentTarget;
  const targetSelector = button.getAttribute('data-target');
  const atCollectionTab = button.closest('.shopify-section--at-products-tabs-collection');

  if (atCollectionTab) {
    const targetTab = atCollectionTab.querySelector(targetSelector);
    
    if (targetTab) {
      atCollectionTab.querySelectorAll('.product-tab.show').forEach(tab => {
        if (tab !== targetTab) {
          tab.classList.remove('show');
          const relatedButton = atCollectionTab.querySelector(`[data-target="#${tab.id}"]`);
          if (relatedButton) {
            relatedButton.classList.remove('active');
          }
        }
      });

      const isTabAlreadyActive = targetTab.classList.contains('show');
      if (!isTabAlreadyActive) {
        targetTab.classList.add('show');
        button.classList.add('active');
      }
    }
  }
};

const attachEventListeners = () => {
  const atMegaMenus = document.querySelectorAll('.at-mega-menu');

  atMegaMenus.forEach(atMegaMenu => {
    atMegaMenu.querySelectorAll('.sub-parent-toggle').forEach(button => {
      button.addEventListener('mouseenter', atHandleMenuToggle); // click
    });

    atMegaMenu.querySelectorAll('.product-tabs-toggle-wrapper .product-tab-toggle').forEach(button => {
      button.addEventListener('click', atHandleTabToggle);
    });
  });

  document.querySelectorAll('.at-panel__wrapper').forEach(panelWrapper => {
    panelWrapper.querySelectorAll('.product-tab-toggle').forEach(button => {
      button.addEventListener('click', handleMobileTabToggle);
    });
    
    panelWrapper.querySelectorAll('.at-menu-toggle-button').forEach(button => {
      button.addEventListener('click', handleMobileMegaMenuToggle);
    });
  });

  const atCollectionProductTabs = document.querySelectorAll('.shopify-section--at-products-tabs-collection');
  atCollectionProductTabs.forEach(atCollectionProductTab => {
    atCollectionProductTab.querySelectorAll('.product-tabs-toggle-wrapper .product-tab-toggle').forEach(button => {
      button.addEventListener('click', atHandleCollectionTabToggle);
    });
  });
};

const setDefaultActiveMenu = () => {
  const atMegaMenus = document.querySelectorAll('.at-mega-menu');

  atMegaMenus.forEach(atMegaMenu => {
    const firstParentButton = atMegaMenu.querySelector('.sub-parent-toggle');

    if (firstParentButton) {
      const firstMenuSelector = firstParentButton.getAttribute('data-target');
      const firstMenu = atMegaMenu.querySelector(firstMenuSelector);

      if (firstMenu) {
        const allButtons = atMegaMenu.querySelectorAll('.sub-parent-toggle');
        const allMenus = atMegaMenu.querySelectorAll('.child-submenu__nav');

        allButtons.forEach(btn => btn.classList.remove('active'));
        allMenus.forEach(m => m.classList.remove('show'));

        firstParentButton.classList.add('active');
        firstMenu.classList.add('show');
      }
    }
  });
};

const setDefaultActiveTab = () => {
  const atMegaMenus = document.querySelectorAll('.at-mega-menu');

  atMegaMenus.forEach(atMegaMenu => {
    const firstTabButton = atMegaMenu.querySelector('.product-tabs-toggle-wrapper .product-tab-toggle');

    if (firstTabButton) {
      const firstTabSelector = firstTabButton.getAttribute('data-target');
      const firstTab = atMegaMenu.querySelector(firstTabSelector);

      if (firstTab) {
        const allTabButtons = atMegaMenu.querySelectorAll('.product-tabs-toggle-wrapper .product-tab-toggle');
        const allTabs = atMegaMenu.querySelectorAll('.product-tabs-wrapper .product-tab');

        allTabButtons.forEach(btn => btn.classList.remove('active'));
        allTabs.forEach(tab => tab.classList.remove('show'));

        firstTabButton.classList.add('active');
        firstTab.classList.add('show');
      }
    }
  });
};

const setMobileDefaultActiveTab = () => {
  document.querySelectorAll('.at-panel__wrapper').forEach(panelWrapper => {
    const firstTabButton = panelWrapper.querySelector('.product-tab-toggle');

    if (firstTabButton) {
      const firstTabSelector = firstTabButton.getAttribute('data-target');
      const firstTab = panelWrapper.querySelector(firstTabSelector);

      if (firstTab) {
        const allTabButtons = panelWrapper.querySelectorAll('.product-tab-toggle');
        const allTabs = panelWrapper.querySelectorAll('.product-tab');

        allTabButtons.forEach(btn => btn.classList.remove('active'));
        allTabs.forEach(tab => tab.classList.remove('show'));

        firstTabButton.classList.add('active');
        firstTab.classList.add('show');
      }
    }
  });
};

const setDefaultCollectionProductActiveTab = () => {
  const atCollectionTabs = document.querySelectorAll('.shopify-section--at-products-tabs-collection');
  atCollectionTabs.forEach(atCollectionTab => {
    const firstTabButton = atCollectionTab.querySelector('.product-tabs-toggle-wrapper .product-tab-toggle');

    if (firstTabButton) {
      const firstTabSelector = firstTabButton.getAttribute('data-target');
      const firstTab = atCollectionTab.querySelector(firstTabSelector);

      if (firstTab) {
        const allTabButtons = atCollectionTab.querySelectorAll('.product-tabs-toggle-wrapper .product-tab-toggle');
        const allTabs = atCollectionTab.querySelectorAll('.product-tabs-wrapper .product-tab');

        allTabButtons.forEach(btn => btn.classList.remove('active'));
        allTabs.forEach(tab => tab.classList.remove('show'));

        firstTabButton.classList.add('active');
        firstTab.classList.add('show');
      }
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  attachEventListeners();
  setDefaultActiveMenu();
  setDefaultActiveTab();
  setMobileDefaultActiveTab();
  setDefaultCollectionProductActiveTab();
});

// js/sections/at-desktop-mega-menu.js
import { timeline as timeline9, stagger as stagger5 } from "vendor";
var reduceMenuAnimation = window.themeVariables.settings.reduceMenuAnimation;
import { DropdownDisclosure } from "theme";
var AtMegaMenuDisclosure = class extends DropdownDisclosure {
  constructor() {
    super();
    this.addEventListener("pointerover", this._preloadImages.bind(this));
  }

  get mouseOverDelayTolerance() {
    return 500;
  }

  _transitionIn(hasOpenSiblings) {
    const timelineSequence = [
      [this.contentElement, { opacity: 1 }, { duration: 0.1 }],
      "at-mega-menu"
    ];
    const contentDelay = hasOpenSiblings ? 0.1 : 0;

    if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches && !reduceMenuAnimation) {
      this.contentElement.querySelectorAll(".sub-child-menus-wrapper .child-submenu__nav").forEach((submenu) => {
        timelineSequence.push([
          submenu.querySelectorAll(":scope > *"),
          { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] },
          { easing: "ease", delay: stagger5(0.025, { start: contentDelay }), at: "at-mega-menu", duration: 0.1 }
        ]);
      });
      
      this.contentElement.querySelectorAll(".parent-submenu__nav > li").forEach((column) => {
        timelineSequence.push([
          column.querySelectorAll(":scope > :first-child, :scope li"),
          { opacity: [0, 1], transform: ["translateY(-10px)", "translateY(0)"] },
          { easing: "ease", delay: stagger5(0.025, { start: contentDelay }), at: "at-mega-menu", duration: 0.1 }
        ]);
      });
    }

    return timeline9(timelineSequence).finished;
  }

  /**
   * When the toggle is hovered we preload the mega-menu images to improve perceived performance
   */
  _preloadImages() {
    Array.from(this.querySelectorAll('img[loading="lazy"]')).forEach((image) => image.setAttribute("loading", "eager"));
  }
};

if (!window.customElements.get("at-mega-menu-disclosure")) {
  window.customElements.define("at-mega-menu-disclosure", AtMegaMenuDisclosure, { extends: "details" });
}

// js/sections/at-mobile-menu.js
import { Delegate as Delegate6 } from "vendor";
import { Drawer } from "theme";
var AtNavigationDrawer = class extends Drawer {
  constructor() {
    super();
    const delegate = new Delegate6(this);
    delegate.on("click", "button[data-panel]", this._onPanelButtonClick.bind(this));
    this._isTransitioning = false;
    this.addEventListener("dialog:after-hide", () => {
      this.reinitializeDrawer();
    });
  }

  get openFrom() {
    return window.matchMedia("(max-width: 699px)").matches ? this.getAttribute("mobile-opening") : super.openFrom;
  }

  switchToPanel(panelIndex, linkListIndex = null) {
    const panels = this.querySelectorAll(".panel");
    let panelToHideTransform, panelToShowTransform, panelToHide = linkListIndex !== null ? panels[parseInt(panelIndex) - 1] : panels[parseInt(panelIndex) + 1], panelToShow = panels[panelIndex], linkLists = panelToShow.querySelectorAll(".panel__wrapper"), timelineSequence = [];
    
    if (document.dir === "rtl") {
      panelToHideTransform = linkListIndex !== null ? ["translateX(0%)", "translateX(100%)"] : ["translateX(0%)", "translateX(-100%)"];
      panelToShowTransform = linkListIndex !== null ? ["translateX(-100%)", "translateX(0%)"] : ["translateX(100%)", "translateX(0%)"];
    } else {
      panelToHideTransform = linkListIndex !== null ? ["translateX(0%)", "translateX(-100%)"] : ["translateX(0%)", "translateX(100%)"];
      panelToShowTransform = linkListIndex !== null ? ["translateX(100%)", "translateX(0%)"] : ["translateX(-100%)", "translateX(0%)"];
    }
    
    timelineSequence.push(
      [panelToHide, { transform: panelToHideTransform, opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.2, opacity: { at: "+0.3" }, transform: { at: "+0.3" } }],
      "panelHidden",
      [panelToShow, { opacity: [0, 1], visibility: ["hidden", "visible"], transform: panelToShowTransform }, { at: "<", transform: { duration: 0.3 } }]
    );

    if (linkListIndex !== null) {
      timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
    }

    timeline9(timelineSequence);
  }

  showPanel(panelIndex, linkListIndex = null) {
    const panels = this.querySelectorAll(".panel");
    let timelineSequence = [], panelToShow = panels[panelIndex], linkLists = panelToShow.querySelectorAll(".panel__wrapper");

    if (!panelToShow.hasAttribute("open") && !this._isTransitioning) {
      this._isTransitioning = true;
      timelineSequence.push(
        [this, { width: [this.offsetWidth + "px", (this.offsetWidth - parseInt(window.getComputedStyle(this).getPropertyValue("padding"))) * 2 + "px"] }, { duration: 0.1 }],
        [panelToShow, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { at: "<" }]
      );

      timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
    }

    if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
      timelineSequence.push([linkLists[this.previousLinkIndex], { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.1 }]);
    }

    timeline9(timelineSequence).finished.then(() => {
      if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
        linkLists[this.previousLinkIndex].removeAttribute("style");
      }
      if (panelToShow.hasAttribute("open") && this.previousLinkIndex !== linkListIndex) {
        timeline9([this.switchLinkList(linkLists, linkListIndex)]);
      }
      this.previousLinkIndex = linkListIndex;
      panelToShow.setAttribute("open", "");
      this._isTransitioning = false;
    });
  }

  switchLinkList(linkLists, linkListIndex) {
    Array.from(linkLists).forEach((item) => {
      item.setAttribute("hidden", "");
    });
    linkLists[linkListIndex].removeAttribute("hidden");
    return [linkLists[linkListIndex].querySelectorAll("li"), { opacity: [0, 1], visibility: ["hidden", "visible"], transform: ["translateY(-10px)", "translateY(0)"] }, { easing: "ease", duration: 0.1, at: "-0.15", delay: stagger5(0.025, { start: 0.1 }) }];
  }

  reinitializeDrawer() {
    if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
      this.style.removeProperty("width");
      this.setExpanded();
    } else {
      const firstPanel = this.querySelector(".panel:first-child");
      firstPanel.style.opacity = "1";
      firstPanel.style.visibility = "visible";
      firstPanel.style.transform = "translateX(0%)";
    }

    Array.from(this.querySelectorAll(".panel:not(:first-child)")).forEach((item) => {
      if (this.hasAttribute("mega-menu")) {
        item.removeAttribute("open");
      }
      item.style.opacity = "0";
      item.style.visibility = "hidden";
      Array.from(item.querySelectorAll(".panel__wrapper")).forEach((list) => list.setAttribute("hidden", ""));
    });
  }

  setExpanded(target) {
    Array.from(this.querySelectorAll("button[data-panel]")).forEach((item) => {
      item.setAttribute("aria-expanded", "false");
    });
    if (target) {
      target.setAttribute("aria-expanded", "true");
    }
  }

  _onPanelButtonClick(event, target) {
    if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
      this.setExpanded(target);
      this.showPanel(...target.getAttribute("data-panel").split("-"));
    } else {
      this.switchToPanel(...target.getAttribute("data-panel").split("-"));
    }
  }
};

if (!window.customElements.get("at-navigation-drawer")) {
  window.customElements.define("at-navigation-drawer", AtNavigationDrawer);
}


// js/sections/at-custom-embedcode.js
var reduceMotion = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
import { animate as animate15, inView as inView11 } from "vendor";
var ATCustomEmbedCode = class extends HTMLElement {
  connectedCallback() {
    if (reduceMotion) {
      Array.from(this.querySelectorAll(".at-custom-embedcode_item")).forEach((item) => {
        inView11(item, (observer) => this.reveal(observer.target));
      });
    }
  }

  reveal(item) {
    const code = item.querySelector(".at-custom-embed-code");
    const content = item.querySelector(".at-custom-embedcode__content");
    const subContent = item.querySelector(".at-custom-embedcode__subcontent");

    animate15(code, { opacity: [0, 1] }, { duration: 0.3 });

    if (content) {
      animate15(content.querySelector(".prose"), { opacity: [0, 1] }, { duration: 0.2, delay: 0.3 });
    }
    
    if (subContent) {
      animate15(subContent.querySelector(".prose"), { opacity: [0, 1] }, { duration: 0.2, delay: 0.4 });
    }
  }
};
if (!window.customElements.get("at-custom-embedcode")) {
  window.customElements.define("at-custom-embedcode", ATCustomEmbedCode);
}

// js/common/at-mobile-localization-drawer.js
var AtMobileLocalizationDrawer = class extends Drawer {
  get shouldAppendToBody() {
    return false;
  }
  get openFrom() {
    return this.getAttribute("open-from") || "right";
  }
};
if (!window.customElements.get("at-mobile-localization-drawer")) {
  window.customElements.define("at-mobile-localization-drawer", AtMobileLocalizationDrawer);
}

// js/sections/at-multi-column-slider.js
import { timeline as timeline13 } from "vendor";
import { imageLoaded } from "theme";
var reduceMotion = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
var ATMultiColumnSlider = class extends HTMLElement {
  connectedCallback() {
    if (reduceMotion) {
      inView11(this, (observer) => this.reveal(observer.target));
    }
  }

  reveal(item) {
    const image = item.querySelector(".at-multi-column-slider__image");
    imageLoaded(image.querySelector("img")).then(() => {
      timeline13([
        [image, { opacity: [0, 1] }, { duration: 0.3 }],
        [image.querySelector("img"), { transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.3, at: "<" }]
      ]);
    });
  }
};
if (!window.customElements.get("at-multi-column-slider")) {
  window.customElements.define("at-multi-column-slider", ATMultiColumnSlider);
}

// js/sections/at-multi-stacked-link.js
var reduceMotion = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
var ATMultiStackedLink = class extends HTMLElement {
  connectedCallback() {
    if (reduceMotion) {
      inView11(this, (observer) => this.reveal(observer.target));
    }
  }

  reveal(item) {
    const image = item.querySelector(".at-multi-stacked-link__image");
    imageLoaded(image.querySelector("img")).then(() => {
      timeline13([
        [image, { opacity: [0, 1] }, { duration: 0.3 }],
        [image.querySelector("img"), { transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.3, at: "<" }]
      ]);
    });
  }
};
if (!window.customElements.get("at-multi-stacked-link")) {
  window.customElements.define("at-multi-stacked-link", ATMultiStackedLink);
}


document.querySelector('a[href="/cart"]').addEventListener('click', function(event) {
  event.preventDefault(); // Optional: Prevent default navigation
  console.log("Cart link clicked");
  document.dispatchEvent(new CustomEvent('cart:refresh'));
});



export {
  AtMegaMenuDisclosure,
  AtNavigationDrawer,
  ATCustomEmbedCode,
  AtMobileLocalizationDrawer,
  ATMultiColumnSlider,
  ATMultiStackedLink
};